import theme from "../js/theme";

var device = function device() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var minOrMaxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'min';
  return "screen and (".concat(minOrMaxWidth, "-width: ").concat(size, "px)");
};

export var BREAKPOINTS = {
  XS: device(theme.breakpoint.s.value - 1, 'max'),
  S: device(theme.breakpoint.s.value),
  M: device(theme.breakpoint.m.value),
  L: device(theme.breakpoint.l.value),
  L_MAX: device(theme.breakpoint.l.value, 'max'),
  XL: device(theme.breakpoint.xl.value)
};